<template>
    <nav class="site-nav flex col-12 justify-between align-middle">
      <router-link to="/" class="site-nav__brand" aria-label="N8Schicht Fotoalben">
        <img class="nav-logo" src="../assets/logo2-negative.svg" alt="Nachtschicht">
        <span>Fotoalben</span>
      </router-link>
      <div class="site-nav__links flex align-middle">
        <router-link to="/gallery-overview" class="site-nav__text-link">
          Alle Alben
        </router-link>
        <router-link to="/shoutout" class="site-nav__action">
          Messageboard
          <span aria-hidden="true">→</span>
        </router-link>
      </div>
    </nav>
</template>
<script>
export default {
  name: "Nav",
  data() {
    return {
      session: {},
    };
  },
  components: {
  }
}
</script>
<style scoped>
.site-nav {
  min-height: 68px;
  padding: 10px clamp(18px, 3vw, 42px);
}
.site-nav__brand {
  display: flex;
  align-items: center;
  gap: 17px;
}
.site-nav__brand span {
  padding-left: 17px;
  border-left: 1px solid rgba(255,255,255,.24);
  color: rgba(255,255,255,.62);
  font-family: 'Archivo', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .16em;
  text-transform: uppercase;
}
.site-nav__links {
  gap: 28px;
}
.site-nav__text-link,
.site-nav__action {
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.site-nav__text-link {
  color: rgba(255,255,255,.72);
}
.site-nav__text-link:hover {
  color: #fff;
}
.site-nav__action {
  min-height: 42px;
  padding: 0 17px;
  display: inline-flex;
  align-items: center;
  gap: 18px;
  color: #fff;
  background: #cc2cce;
  transition: transform .25s ease, box-shadow .25s ease, background .2s ease;
}
.site-nav__action:hover {
  background: #dc4ede;
  box-shadow: 0 10px 28px rgba(204,44,206,.3);
  transform: translateY(-2px);
}
@media (max-width: 600px) {
  .site-nav__brand span,
  .site-nav__text-link {
    display: none;
  }
  .site-nav__links {
    gap: 10px;
  }
  .site-nav__action {
    min-height: 38px;
    padding: 0 12px;
    font-size: 9px;
  }
}
</style>
